import { render, staticRenderFns } from "./workers_admin.vue?vue&type=template&id=b3ae6872&scoped=true"
import script from "./workers_admin.vue?vue&type=script&lang=js"
export * from "./workers_admin.vue?vue&type=script&lang=js"
import style0 from "./workers_admin.vue?vue&type=style&index=0&id=b3ae6872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae6872",
  null
  
)

export default component.exports